import styled from 'styled-components';
import { colors, spacing, body1, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const DestinationCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: ${pxToRem(86)};
  gap:  ${spacing.base};
  background: ${colors.backgroundPrimary};
  cursor: pointer;
  border: ${spacing.single} solid ${colors.borderPrimary};
  border-radius: ${spacing.half};
  ${smallShadow};
  ${body1};
  padding: ${pxToRem(20)} ${spacing.base};
   
  &[data-disabled="true"] {
    opacity: 0.5;
  }

  &[data-selected="true"] {
    border: ${pxToRem(3)} solid ${colors.purple50};
  }

  &:hover {
    &[data-selected="false"] {
      &[data-disabled="false"] {
      cursor: pointer;
      border: ${spacing.single} solid ${colors.borderEmphasis};
      } 
    }
  }
`;

export const DestinationCardIcon = styled.div`
  display: flex;
  align-items: center;
`;
